import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';
import { Toaster } from "sonner";
import App from './App';
import theme from "./theme"



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
      <Toaster richColors expand={false} />
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
